import { Practicum } from "../../../../features/Practicum";
import { PracticumPage } from "../../../../pages/PracticumPage";
import { appRouterPaths } from "../../../../services/navigation/urls";
import type { AppRouteProps } from "../../types";

export const practicumPageRouteConfig: AppRouteProps = {
  path: appRouterPaths.practicum.root,
  element: <PracticumPage />,
  name: "Практикум",
  children: appRouterPaths.practicum.item
    ? [
        {
          path: appRouterPaths.practicum.item,
          element: <Practicum />,
          name: "Объекты практикума",
        },
      ]
    : undefined,
};
